<div (click)="cancelAction()" class="dialog-bg"></div>
<div class="dialog">
  <div class="dialog-container">
    <span class="bg-primary-300 w-full py-2 px-4 text-white mb-4">
  {{ data?.article }}
  </span>
    <span class="px-4 mb-4">
    {{data?.content}}
  </span>
    <div class="px-4 mb-4 flex flex-row gap-2">
      <button (click)="cancelAction()" class="wilo-btn inversion">Назад</button>
    </div>
  </div>
</div>
